/* eslint-disable import/no-mutable-exports, global-require */

let fetch;

if (__CLIENT__) {
  require('whatwg-fetch');

  fetch = window.fetch.bind(window);
} else {
  fetch = require('node-fetch').default;
}

export default fetch;
